import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CarouselCard from '../CarouselCard';
import foodImage1 from '../../assets/images/food/carousel/carousel-new-1.png';
import foodImage2 from '../../assets/images/food/carousel/carousel-new-2.png';
import foodImage3 from '../../assets/images/food/carousel/carousel-new-3.png';
import foodImage4 from '../../assets/images/food/carousel/carousel-new-4.png';

const ReactFlickSlider = () => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          // dots: true,
          swipeToSlide: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          // dots: false,
          swipeToSlide: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // dots: true,
          swipeToSlide: true
        }
      }
    ]
  };
  return (
    <div>
      <Slider {...settings}>
        <CarouselCard name={foodImage1} />
        <CarouselCard name={foodImage2} />
        <CarouselCard name={foodImage3} />
        <CarouselCard name={foodImage4} />
        <CarouselCard name={foodImage1} />
        <CarouselCard name={foodImage2} />
      </Slider>
    </div>
  );
};

export default ReactFlickSlider;
